// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2BNoy","empty":"ModalGraph_empty__1cg0o"};